import { ChevronDown } from "react-feather";
import styles from "../../communication-chat.module.css";

const EmployeeGlobalList = (props) => {
  const employees = props.employees || [];

  return (
    <div
      className={
        props.accordionOnForEmployee
          ? `${styles.accordionOn} ${styles.Open}`
          : `${styles.accordionOn}`
      }
    >
      <p
        className={`${styles.ListAccoudionTitle}`}
        onClick={() => props.toggleAccordionForEmployee()}
      >
        <ChevronDown /> Employees <span>{employees.length}</span>
      </p>
      <div>
        {employees.map((emp) => (
          <div
            key={emp.id}
            className={`${styles.CommuListSec}`}
            onClick={(e) => {
              e.stopPropagation();
              props.onSelectEmployee(emp);
            }}
          >
            <div className={`${styles.EmployeeListDeSec}`}>
              <div className={`${styles.EmployeeAvatarSec}`}>
                <img
                  src={emp.avatar}
                  alt=""
                  className={`${styles.EmpAvatarImg}`}
                />
                <span
                  className={`${styles.StatusBadge} ${
                    emp.online ? styles.Online : ""
                  }`}
                ></span>
              </div>
              <div>
                <p className={`${styles.ProsTenantList}`}>
                  <span>{emp.name}</span>
                </p>
                <p className={`${styles.ProsTenantListDe}`}>
                  <span>{emp.property}</span>
                  <span>{emp.role}</span>
                </p>
              </div>
            </div>
          </div>
        ))}
        {employees.length === 0 && (
          <div className={`${styles.NoDataSecOnlyText}`}>
            <img src="/static/img/chatIcon.png" alt="" />
            <p>No employee here!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeGlobalList;
